{
  "close": "Kapat",
  "notifications": "Bildirimler"
}
